module.exports = __webpack_public_path__ + "img/secure-logos-och-pay.460826ec.png";